export default __webpack_public_path__ + "static/media/StepTurningImg.1e7c3027.jpg";